const BUCKET_NAME = 'state.starred';

export default class ThingStarController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        this.thingStarred = false;
    }

    $onChanges(changes) {
        if (changes.reset) {
            if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                this.resetValues();
            }
        }
    }

    onChange() {
        if (this.thingStarred) {
            this.fillBucket();

            this.pushUpdate(
                this.eventEmitter({
                    value: this.thingStarred
                })
            );
        } else {
            this.clearBucket();
        }
    }

    fillBucket() {
        this.addItemToBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: this.thingStarred
                }
            })
        );
    }

    clearBucket() {
        this.removeItemFromBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            })
        );
    }

    resetValues() {
        this.thingStarred = false;

        this.clearBucket();
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-star/thing-star.controller.js